import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import UserDisplay from '../UserDisplay';
import VerifiedUsers from './VerifiedUsers';
import PendingUsers from './PendingUsers';
import RejectedUsers from './RejectedUsers';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import CreateUser from '../CreateUser';

const AllUsersPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleCanvas = () => {
        setIsOpen(!isOpen);
        setRefreshKey(prevKey => prevKey + 1);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h2>All Users</h2>
                <div className='d-flex align-items-center justify-content-end'>
                    <div className="me-3">
                        <input
                            type="text"
                            className="form-control w-300px rounded-50 ps-3"
                            style={{ height: '50px' }}
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary rounded-pill px-5"
                        onClick={toggleCanvas}
                        style={{
                            height: '50px',
                            fontWeight: '600',
                            border: 'none',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        }}
                    >
                        Create User
                    </button>
                </div>
            </div>

            <UserDisplay 
                key={refreshKey} 
                searchQuery={searchQuery} 
                status="all"
            />

            <Offcanvas isOpen={isOpen} toggle={toggleCanvas} className="custom-canvas-width" direction='end'>
                <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCanvas}>
                    <span className='font-weight-bold'>Create User</span>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <CreateUser />
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

const UserManagementLayout = () => {
  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content' style={{ flex: 1, overflow: 'auto', padding: '20px' }}>
        <Routes>
          <Route index element={<AllUsersPage />} />
          <Route path="verified" element={<VerifiedUsers />} />
          <Route path="pending" element={<PendingUsers />} />
          <Route path="rejected" element={<RejectedUsers />} />
          <Route path="*" element={<Navigate to="/users" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default UserManagementLayout;

